import {createSlice} from "@reduxjs/toolkit";
import {login, logout} from "../../common/account/accountSlice";

const initialState = {
    viewMode: 'CONTACT',
    exploreMode: {
        mode: 'COMPANY',
        company: {
            sections: {
                // COMPANY: true
            },
            toggleMap: true,
        },
        contact: {
            sections: {},
        }
    },
    map: null,
    overlaySelect: null
};

const exploreSlice = createSlice({
    name: 'explore', initialState,
    reducers: {
        setExploreMode: {
            reducer(state, action) {
                state.exploreMode = action.payload;
            }
        },
        setExploreMap: {
            reducer(state, action) {
                state.map = action.payload;
            }
        },
        setCompanyMode: {
            reducer(state) {
                state.exploreMode.mode = 'COMPANY';
                return state;
            }
        },
        setOverlaySelect: {
            reducer(state, action) {
                state.overlaySelect = action.payload;
                return state;
            }
        },
    },
    extraReducers: (builder) => {
        // This slice (map instance, selected overlay, view mode) is plain
        // in-memory state — not in the redux-persist whitelist and, unlike
        // universeSlice, was never reset on auth transitions. A logout/login
        // inside the same SPA session (no full page reload) left the previous
        // user's overlaySelect in place; ExploreMap re-applies it to the map
        // on mount (see ExploreMap.jsx's overlaySelect effect), so the next
        // user who logs in saw the prior user's overlay selection as a pill.
        builder.addCase(login.fulfilled, () => initialState);
        builder.addCase(logout.fulfilled, () => initialState);
    },
})


export const {setExploreMode, setExploreMap, setCompanyMode, setOverlaySelect} = exploreSlice.actions;
export default exploreSlice.reducer;
